export const ShieldIcon = (props) => (
  <svg
    {...props}
    width={props?.width || '40'}
    height={props?.height || '40'}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.9998 36.6654C19.9998 36.6654 33.3332 29.9987 33.3332 19.9987V8.33203L19.9998 3.33203L6.6665 8.33203V19.9987C6.6665 29.9987 19.9998 36.6654 19.9998 36.6654Z"
      stroke={props?.color || '#3966E0'}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
